// extracted by mini-css-extract-plugin
export default {"infoCont":"SliderInfo_infoCont__b6pnT"};